// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"7c62c092","44":"e6ea0a4e","409":"fff0c8cc","591":"5717f89e","631":"8cd8275a","727":"65a4008a"}[chunkId] + ".chunk.js";
};